/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Response_CanceledInputs */



/**
* | output |
* | --- |
* | "Response canceled by user" |
*
* @param {Chat_Response_CanceledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_response_canceled = /** @type {((inputs?: Chat_Response_CanceledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Response_CanceledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Antwort vom Benutzer abgebrochen")
	return /** @type {LocalizedString} */ ("Response canceled by user")
});